import { render, staticRenderFns } from "./TopicCreate.vue?vue&type=template&id=2578eb8e&"
import script from "./TopicCreate.vue?vue&type=script&lang=ts&"
export * from "./TopicCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports